module.exports = __webpack_public_path__ + "img/infinity.d367489b.png";